module.exports = __webpack_public_path__ + "img/moderation_red.07592cee.svg";